export const COLLECTIONS = Object.freeze({
  ADMINS: "Admins",
  TAGS: "Tags",
  COLLECTED_POINTS: "CollectedPoints",
  BOUNDARIES: "Boundaries",
  COLLECTED_PLACES_DETAILS: "CollectedPlacesDetails",
  COUNTRIES: "Countries",
  CURVE_ROADS: "CurveRoads",
  CATEGORY_TAGS: "CategoryTags",
  BEST_BIKING_ROADS: "BestBikingRoads",
  PRIVATE_TAGS: "PrivateTags",
  PLACES_LOGS: "PlacesCollectingLogs",
  PLACES: "Places",
  GRAPHHOPER_KEYS: "GraphhopperKeys",
  Dump: "Dump",
  MEMBERS: "Members",
  GRAPHHOPPER_API_KEYS: "GraphhopperApiKeys",
  ROUTES: "Routes",
});

export const FUNCTIONS = Object.freeze({
  PACK_CIRCLES_IN: "packCirclesIn",
  INIT_PLACES_PARSING: "initPlacesParsing",
  INIT_COLLECT_PLACES: "initCollectPlaces",
  PLACE_AVAILABILITY_FOR_ROUTE: "checkAvailabilityForRoute",
  BUILD_ROUTE: "buildRoute",
  BUILD_ROUTE_DEV: "buildRouteDev",
  AUTH_MEMBER: "authMember",
  UPLOAD_TO_DUMP: "uploadToDump",
  GET_CATEGORIES: "getCategoriesList",
  GET_ROUTES_LIST: "getRoutesList",
  GET_USERS_ROUTES: "getUsersRoutes",
  RATE_ROUTE: "rateRoute",
});
